import { render, staticRenderFns } from "./RedirectLinkedin.vue?vue&type=template&id=6fe74776&"
import script from "./RedirectLinkedin.vue?vue&type=script&lang=js&"
export * from "./RedirectLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports